export enum SidebarMenuItems {
  HOME = 'home',
  ORDERS = 'poc-orders',
  DATES_AVAILABILITY = 'poc-dates-availability',
  PENDING = 'poc-pending-orders',
  SCHEDULED = 'poc-scheduled-orders',
  MAP = 'poc-orders-map',
  HISTORY = 'poc-history',
  STOCK = 'poc-inventory',
  INVENTORY = 'poc-products',
  ON_SALE = 'poc-on-sale',
  PERFORMANCE = 'poc-performance',
  FINANCIAL = 'poc-financial',
  MANAGEMENT = 'poc-management',
  FINANCIAL_REPORT = 'financial-report',
  ONLINE_PAYMENT = 'poc-online-payment',
  FLEET_MANAGEMENT = 'poc-fleet-management',
  MY_ACCOUNT = 'poc-my-account',
  DYNAMIC_RADIUS = 'poc-dynamic-radius',
  PARTNER_GUIDE = 'poc-guide',
  FAQ = 'poc-faq',
  LOGOUT = 'logout-sidebar-menu-item',
}
